import { Typography } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../../../../Icon"

import styles from "./styles.module.less"

const { Title, Text } = Typography

// §BLOCK 4.10 — empty-state коли програма Active, але лукапів немає.
// Іконка + заголовок + опис, центровано; фільтри/сортування/експорт залишаються активними.
const EmptyLookups = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.wrap}>
      <span className={styles.icon}>
        <Icon type="receipt_bill" style={{ fontSize: 50 }} />
      </span>
      <Title level={3} className={styles.title}>
        {t("Reduce disputes with Digital Receipt")}
      </Title>
      <Text type="secondary" className={styles.text}>
        {t(
          "Show cardholders clear purchase details so they recognize legitimate charges and file fewer disputes."
        )}
      </Text>
    </div>
  )
}

export default EmptyLookups
